/* global fetch */
import { checkStatus, parseJSON } from "./utils";

export function auth(idToken) {
    const baseAPI = process.env.REACT_APP_API_BASE || "";
    return fetch(baseAPI + "/auth?idToken=" + encodeURIComponent(idToken), {
        headers: {
            Accept: "application/json"
        }
    })
        .then(checkStatus)
        .then(parseJSON);
}



// WEBPACK FOOTER //
// ./src/api/auth.js